import React, { useState, useRef, useEffect } from 'react';
import soundManager from '../utils/soundEffects';
import './Windows98Player.css';

const Windows98Player = () => {
  const [isPlaying, setIsPlaying] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [isMinimized, setIsMinimized] = useState(false);
  const audioRef = useRef(null);

  const track = {
    name: "Genie In A Bottle - Christina Aguilera",
    url: "https://files.catbox.moe/fegzmf.mp3" // You'll need to replace this with the actual Genie in a Bottle audio URL
  };

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    const updateTime = () => setCurrentTime(audio.currentTime);
    const updateDuration = () => setDuration(audio.duration);

    audio.addEventListener('timeupdate', updateTime);
    audio.addEventListener('loadedmetadata', updateDuration);

    return () => {
      audio.removeEventListener('timeupdate', updateTime);
      audio.removeEventListener('loadedmetadata', updateDuration);
    };
  }, []);

  const formatTime = (time) => {
    if (isNaN(time)) return '0:00';
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
  };

  const togglePlay = () => {
    soundManager.playClick();
    const audio = audioRef.current;
    if (isPlaying) {
      audio.pause();
    } else {
      audio.play();
    }
    setIsPlaying(!isPlaying);
  };

  const handleSeek = (e) => {
    const audio = audioRef.current;
    const seekTime = (e.target.value / 100) * duration;
    audio.currentTime = seekTime;
  };

  const handleMinimize = () => {
    soundManager.playClick();
    setIsMinimized(!isMinimized);
  };

  if (isMinimized) {
    return (
      <div className="window" onClick={handleMinimize} style={{ cursor: 'pointer' }}>
        <div className="window-header text-xs flex items-center gap-2">
          <img src="https://loveberry.nekoweb.org/assets/musicplayer/player-icon.png" alt="" height="14px" width="14px" />
          <span>CD Player</span>
        </div>
      </div>
    );
  }

  return (
    <div id="musicplayer">
      <div className="title-color">
        <div className="actual-title">
          <img src="https://loveberry.nekoweb.org/assets/musicplayer/player-icon.png" alt="" height="14px" width="14px" />
          CD Player
        </div>
        <div className="title-bar-controls">
          <button className="window-button minimize" onClick={handleMinimize}></button>
          <button className="window-button maximize" onClick={() => soundManager.playClick()}></button>
          <button className="window-button close" onClick={() => soundManager.playClick()}></button>
        </div>
      </div>
      <div className="player-flex">
        <div className="player-icon-holder">
          <div className="player-icon"></div>
        </div>
        <div className="player-main">
          <select className="track-select" value="0">
            <option value="0">{track.name}</option>
          </select>
          <div className="controls">
            <div className="seeking">
              <div className="current-time">{formatTime(currentTime)}</div>
              <input
                type="range"
                min="0"
                max="100"
                value={(currentTime / duration) * 100 || 0}
                className="seek_slider"
                onChange={handleSeek}
              />
              <div className="total-duration">{formatTime(duration)}</div>
            </div>
            <div className="player-buttons">
              <button className="window-button prev-track" onClick={() => soundManager.playClick()}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M17.971 4.285A2 2 0 0 1 21 6v12a2 2 0 0 1-3.029 1.715l-9.997-5.998a2 2 0 0 1-.003-3.432z"/>
                  <path d="M3 20V4"/>
                </svg>
              </button>
              <button className="window-button playpause-track" onClick={togglePlay}>
                {isPlaying ? (
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect width="4" height="16" x="6" y="4"/>
                    <rect width="4" height="16" x="14" y="4"/>
                  </svg>
                ) : (
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M5 5a2 2 0 0 1 3.008-1.728l11.997 6.998a2 2 0 0 1 .003 3.458l-12 7A2 2 0 0 1 5 19z"/>
                  </svg>
                )}
              </button>
              <button className="window-button next-track" onClick={() => soundManager.playClick()}>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 4v16"/>
                  <path d="M6.029 4.285A2 2 0 0 0 3 6v12a2 2 0 0 0 3.029 1.715l9.997-5.998a2 2 0 0 0 .003-3.432z"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
      <audio
        ref={audioRef}
        src={track.url}
        onPlay={() => setIsPlaying(true)}
        onPause={() => setIsPlaying(false)}
      />
    </div>
  );
};

export default Windows98Player;
